export default __webpack_public_path__ + "alberta-product-group-checkmark.b5926736d3c7206a37ae.svg";